'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useFormController = require('../hooks/useFormController.js');
var FormFields = require('./FormFields.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SchemaFields = function SchemaFields() {
  var _useFormController = useFormController.useFormController(),
    getOptions = _useFormController.getOptions;

  // Grap the schema
  var _getOptions = getOptions(),
    schema = _getOptions.schema;
  return /*#__PURE__*/React__default["default"].createElement(FormFields.FormFields, {
    schema: schema
  });
};

exports.SchemaFields = SchemaFields;
